import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { CalendarIcon } from '@calendly/ui/components/icons'

import { useEventType } from 'features/event_type_provider'
import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction'


export const CalendarViewControl = ({ onClick }) => {
  const eventType = useEventType()

  const trackViewCalendar = useTrackAvailabilityInteraction({
    eventType,
    location: 'et_editor',
    action: 'view_calendar'
  })

  const handleClick = (event) => {
    trackViewCalendar()
    return onClick(event)
  }

  return (
    <Button
      decoration="secondary-outline"
      onClick={handleClick}
      size="small"
    >
      <CalendarIcon />
      {I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.view_calendar')}
    </Button>
  )
}
